import { FC } from 'react';
import styles from './Brands.module.scss';
import { SectionTitle } from '../../../../SectionTitle/SectionTitle';
import { useGetBrands } from '../../../../../queries/brands/useGetBrands';
import { Brand } from '../../../../Brand/Brand';
import { IBrandProps } from '../../../../Brand/Brand';
import clsx from 'clsx';

export interface IBrandsProps {
  withTitle?: boolean;
  className?: string;
  classNameItem?: string;
  href?: string;
  data: IBrandProps[];
}

const Brands: FC<IBrandsProps> = ({
  withTitle = true,
  href,
  data,
  className,
  classNameItem,
}) => {
  const { brandsData } = useGetBrands({
    'where[isActive][equals]': 'true',
    limit: 0,
  });

  if (!brandsData || brandsData?.docs.length === 0) return null;

  return (
    <div className={styles.Brands}>
      {withTitle && (
        <SectionTitle className={styles.title}>
          <h2>Бренды</h2>
        </SectionTitle>
      )}
      <div className={clsx(styles.wrapper, className)}>
        {data.map((item, index) => (
          <Brand
            key={index}
            href={href}
            classNameFromPage={classNameItem}
            classNameItem={styles.item}
            {...item}
          />
        ))}
      </div>
    </div>
  );
};

export default Brands;
